import styled from 'styled-components';
import {Typography} from '@/components/Typography';
import {interceptProps} from '@/styled-components';
import {palette} from '@/styles';

export const ReportContainer = styled.div`
  padding: 28px 16px 140px;
`;

export const SectionValue = styled(Typography).attrs({
  variant: 'bold18',
})``;

export const SectionLabel = styled(Typography).attrs({
  variant: 'bold16',
})``;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const TableRow = styled.tr`
  color: ${palette.gray900};
  font-size: 14px;
  border-bottom: 1px solid ${palette.gray100};
`;

export const TableCell = styled('td').withConfig({
  shouldForwardProp: interceptProps(['ellipsis']),
})<{
  ellipsis?: boolean;
}>`
  text-align: center;
  padding: 16px 9px;
  max-width: 0;

  &:first-of-type {
    text-align: left;
    padding-left: 20px;
  }
  &:last-of-type {
    text-align: right;
    padding-right: 20px;
  }
  ${({ellipsis}) =>
    ellipsis &&
    `
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  `}
`;

export const TableHeaderRow = styled(TableRow)`
  background-color: ${palette.gray100};
  color: ${palette.gray600};
  font-size: 12px;
  ${TableCell} {
    padding: 8px 20px;
    white-space: nowrap;
  }
`;

export const ColorCircle = styled('div').withConfig({
  shouldForwardProp: interceptProps(['color']),
})<{
  color?: string;
}>`
  width: 10px;
  height: 10px;
  flex-shrink: 0;
  border-radius: 100%;
  ${({color}) => color && `background-color: ${color};`}
`;
